import axios, { InternalAxiosRequestConfig } from "axios";

// Platform API
export const defaultApi = axios.create({
  // baseURL: "https://api.vps2.online/",
  // Use the final origin directly to avoid CORS preflight redirect (https -> http).
  // baseURL: "https://714c-91-123-155-200.ngrok-free.app/",
  // MAIN baseURL: "https://ofiice-edu.tech/api/",
  baseURL: "https://ofiice-edu.tech/api/",
  headers: {
    "ngrok-skip-browser-warning": "1",
  },
});

export const admissionDatabaseBaseUrl = "https://qarshisu.net/";
export const admissionDatabaseApi = axios.create({
  baseURL: admissionDatabaseBaseUrl,
});

// Add token to API
const attachToken = (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
  const accessToken = localStorage.getItem("accessToken") || "";

  if (accessToken) {
    config.headers.Authorization = `Bearer ${accessToken}`;
  }

  return config;
};

/** Let the browser set multipart boundary; a preset Content-Type breaks file uploads (422). */
const prepareMultipartBody = (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
  if (config.data instanceof FormData) {
    config.headers.delete("Content-Type");
  }
  return config;
};

const applyRequestDefaults = (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig => prepareMultipartBody(attachToken(config));

defaultApi.interceptors.request.use(applyRequestDefaults, (error) => Promise.reject(error));
admissionDatabaseApi.interceptors.request.use(attachToken, (error) => Promise.reject(error));
